import { render } from "./MenuPermissionInquiry.vue?vue&type=template&id=48e2a677&ts=true"
import script from "./MenuPermissionInquiry.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuPermissionInquiry.vue?vue&type=script&setup=true&lang=ts"

import "./MenuPermissionInquiry.vue?vue&type=style&index=0&id=48e2a677&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/scan/admin/MenuPermissionInquiry.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48e2a677"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48e2a677', __exports__)) {
    console.log('reload')
    api.reload('48e2a677', __exports__)
  }
  
  module.hot.accept("./MenuPermissionInquiry.vue?vue&type=template&id=48e2a677&ts=true", () => {
    console.log('re-render')
    api.rerender('48e2a677', render)
  })

}


export default __exports__